import { initializeApp } from 'firebase';
import 'firebase/firestore';

const app = initializeApp({
    apiKey: "AIzaSyC9_mx5Zkk3hp7Bl7JkAPZDvcY8gJCwcRg",
    authDomain: "union-of-aries.firebaseapp.com",
    databaseURL: "https://union-of-aries.firebaseio.com",
    projectId: "union-of-aries",
    storageBucket: "",
    messagingSenderId: "706172008422"
  });

export const db = app.firestore();
export const rsvpsRef = db.collection('rsvps');


// WEBPACK FOOTER //
// ./src/firebase.js